import { defineStore } from 'pinia';

export const useSmarticoViewStore = defineStore('smarticoView', () => {
  const mainView = ref<'minigames' | 'history'>('minigames');

  const { isAuthenticated } = storeToRefs(useAuthStore());
  const { openLogin } = useAuth();

  function toggleView() {
    if (mainView.value === 'minigames' && !isAuthenticated.value) {
      openLogin();

      return;
    }

    mainView.value = mainView.value === 'minigames' ? 'history' : 'minigames';
  }

  return {
    mainView,
    toggleView,
  };
});
